import { useAtomValue } from "jotai";
import type { Dispatch, SetStateAction } from "react";
import { useEffect } from "react";

import { articleSpeechPlayerAtom } from "~/components/article/article-speech/article-speech-player/atoms";

type UseSpeechifyPlayerParameters = {
  isAdPlaying: boolean;
  setManualPaused: Dispatch<SetStateAction<boolean>>;
};

export const useSpeechifyPlayer = ({
  isAdPlaying,
  setManualPaused,
}: UseSpeechifyPlayerParameters) => {
  const { articleSpeechPlayer, isArticleSpeechPlayerPlaying } =
    useAtomValue(articleSpeechPlayerAtom);

  useEffect(() => {
    if (isArticleSpeechPlayerPlaying) {
      setManualPaused(true);
    }
  }, [isArticleSpeechPlayerPlaying, setManualPaused]);

  useEffect(() => {
    if (isAdPlaying) {
      articleSpeechPlayer?.pause();
    }
  }, [articleSpeechPlayer, isAdPlaying]);

  return {
    articleSpeechPlayer,
    isArticleSpeechPlayerPlaying,
  };
};
